var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2836 7.27584L13.3328 6.411L10.6726 1.01803C10.6 0.87037 10.4805 0.750839 10.3328 0.678183C9.96248 0.49537 9.51248 0.647714 9.32733 1.01803L6.66717 6.411L0.716389 7.27584C0.552327 7.29928 0.402327 7.37662 0.287483 7.49381C0.148643 7.63651 0.0721362 7.8285 0.074773 8.02758C0.0774098 8.22666 0.158975 8.41655 0.301545 8.55553L4.60701 12.7532L3.58983 18.6805C3.56597 18.8184 3.58123 18.9602 3.63387 19.0899C3.68651 19.2195 3.77442 19.3318 3.88764 19.4141C4.00086 19.4963 4.13486 19.5452 4.27444 19.5551C4.41401 19.5651 4.55358 19.5357 4.67733 19.4704L9.99998 16.6719L15.3226 19.4704C15.468 19.5477 15.6367 19.5735 15.7984 19.5454C16.2062 19.4751 16.4805 19.0883 16.4101 18.6805L15.393 12.7532L19.6984 8.55553C19.8156 8.44068 19.893 8.29068 19.9164 8.12662C19.9797 7.71646 19.6937 7.33678 19.2836 7.27584Z",
    fill: "#A09E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.e0cb8e70842074abcafe95487dfdc42f.svg";
export { ForwardRef as ReactComponent };